import React from 'react';
import { collection, addDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

function TrialExpired({ user, trialEnd }) {
  // 決済情報登録ボタンのクリック時処理（firestore-stripe-payments拡張方式）
  const handleCheckout = async () => {
    if (!user) return;
    try {
      const selectedPrice = {
        price: process.env.REACT_APP_STRIPE_PRICE_ID,
        quantity: 1,
      };

      // 残りトライアル日数を計算（終了済みなら0）
      let trialDays = 0;
      if (trialEnd) {
        const now = new Date();
        const diffTime = trialEnd.getTime() - now.getTime();
        trialDays = Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
      }

      const checkoutSession = {
        automatic_tax: true,
        cancel_url: window.location.origin,
        collect_shipping_address: true,
        line_items: [selectedPrice],
        metadata: {
          key: 'value',
        },
        mode: 'subscription',
        success_url: window.location.origin,
        tax_id_collection: true,
        // 残りトライアル日数があれば設定（トライアル終了後は0なので設定しない）
        ...(trialDays > 0 && { trial_period_days: trialDays }),
        subscription_data: {
          items: [
            {
              price: process.env.REACT_APP_STRIPE_PRICE_ID
            }
          ],
        },
      };

      const docRef = await addDoc(collection(db, 'customers', user.uid, 'checkout_sessions'), checkoutSession);
      onSnapshot(docRef, (snap) => {
        const { error, url } = snap.data() || {};
        if (error) {
          alert(`エラーが発生しました: ${error.message}`);
        }
        if (url) {
          window.location.assign(url);
        }
      });
    } catch (e) {
      alert('決済ページの生成に失敗しました');
    }
  };

  return (
    <div className="TrialExpired" style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      width: '100%'
    }}>
      <Box sx={{ 
        width: '100%', 
        maxWidth: 480,
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center',
        px: 3,
        textAlign: 'center'
      }}>
        <Box sx={{ mb: 4 }}>
          <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#d32f2f', marginBottom: '16px' }}>
            無料トライアルが終了しました
          </div>
          <div style={{ fontSize: '0.95rem', color: '#666', lineHeight: 1.8 }}>
            引き続きサービスをご利用いただくには、<br />
            決済情報のご登録が必要です。
          </div>
        </Box>
        <Button
          variant="contained"
          color="primary"
          sx={{ width: '80%', maxWidth: 320, fontWeight: 'bold', fontSize: '1.1rem', py: 1.5 }}
          onClick={handleCheckout}
        >
          決済情報を登録する
        </Button>
        <div style={{ fontSize: '0.85rem', color: '#999', marginTop: '24px' }}>
          決済情報を登録すると、<br />
          すべての機能がご利用いただけます。
        </div>
      </Box>
    </div>
  );
}

export default TrialExpired;
